import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { STORE_NAME, STORE_VERSION } from "../constants";
import type { RelocateFormSchema } from "../routes/authenticated/relocate";

export const APP_STORE_NAME = `${STORE_NAME}_APP`;
export interface AppState {
	relocateForm: RelocateFormSchema;

	setRelocateForm: (form: RelocateFormSchema | null) => void;

	/**
	 * Action to remove the token
	 */
	resetState: () => void;
}

export const getDefaultRelocateFormData = (): RelocateFormSchema => ({
	meterReading: "",
	relocationDate: "",
	invoiceAddress: "",
	postalCode: "",
	place: "",
	newOwnerName: "",
	newOwnerBirthdate: "",
	newOwnerTlf: "",
	newOwnerEmail: "",
	newOwnerAddress: "",
	newOwnerPostalCode: "",
	newOwnerPlace: "",
	newOwnerIsAware: false,
});

// Due to typescript quirks, this has to all be in one giant object for inference
export const useAppStore = create<AppState>()(
	// Allows us to use Redux devtools in the browser
	devtools(
		// Persists the state to the localStorage in the browser
		persist(
			// Wraps Immer around the set function
			immer((set) => ({
				relocateForm: getDefaultRelocateFormData(),
				setRelocateForm: (form) =>
					// set is a state alteration method from Zustand
					set(
						// state is the previous state, normally this should not be altered,
						// but with Immer, it is the preferred way to do it
						(state) => {
							state.relocateForm = form ?? getDefaultRelocateFormData();
						},
						// If true, it will overwrite the entire state with the state from the callback
						false,
						// Used to give a name to the logged action in redux devtools
						"app/setRelocateForm",
					),
				resetState: () =>
					// set is a state alteration method from Zustand
					set(
						// state is the previous state, normally this should not be altered,
						// but with Immer, it is the preferred way to do it
						(state) => {
							state.relocateForm = getDefaultRelocateFormData();
						},
						// If true, it will overwrite the entire state with the state from the callback
						false,
						// Used to give a name to the logged action in redux devtools
						"app/resetState",
					),
			})),
			// Persist options
			{
				name: APP_STORE_NAME,
				version: STORE_VERSION,
			},
		),
		// Devtools options
		{
			name: APP_STORE_NAME,
			trace: import.meta.env.DEV,
		},
	),
);
